import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { InnerBodyType } from "../multisplitOptions/types";
import DualPrice from "components/Price";

interface Props {
  item: InnerBodyType;
}

//  IMAGE SHOULD BE 400px > laptopL

const MultisplitOptionTableRow: React.FC<Props> = ({ item }) => {
  return (
    <RowContainer>
      <InnerBodyImage className="row-item">
        <ItemImage
          src={`data:${item.image.image.contentType};base64,${item.image.image.image}`}
        />
      </InnerBodyImage>
      <Model className="row-item text-body">{item.model}</Model>
      <Price className="row-item text-body">
        <DualPrice bgn={item.price} eur={item.price_eur} />
      </Price>
    </RowContainer>
  );
};

const RowContainer = styled.div`
  & + & {
    margin-top: 20px;
  }

  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .row-item {
    margin-top: 10px;
  }

  .row-item:first-child {
    flex: 0 0 180px; // 20 less than container so there is margin
  }

  @media only screen and (${device.mobileM}) {
    .row-item:first-child {
      flex: 0 0 225px; // 20 less than container so there is margin
    }
  }

  @media only screen and (${device.mobileL}) {
    .row-item:first-child {
      flex: 0 0 240px; // 20 less than container so there is margin
    }
  }

  @media only screen and (${device.tablet}) {
    flex-flow: row nowrap;
    align-items: center;

    .row-item {
      flex: 1;
      padding-right: 20px;
      margin-top: 0;
    }

    .row-item:first-child {
      flex: 0 0 260px; // 20 less than container so there is margin
    }
  }

  @media only screen and (${device.laptop}) {
    .row-item:first-child {
      flex: 0 0 300px; // 20 less than container so there is margin
    }
  }

  @media only screen and (${device.laptopL}) {
    .row-item:first-child {
      flex: 0 0 400px; // 20 less than container so there is margin
    }
  }
`;
const InnerBodyImage = styled.div`
  width: 240px;
  height: 180px;

  @media only screen and (${device.mobileM}) {
    width: 300px;
    height: 225px;
  }

  @media only screen and (${device.mobileL}) {
    width: 320px;
    height: 240px;
  }

  @media only screen and (${device.tablet}) {
    height: 195px;
  }

  @media only screen and (${device.laptop}) {
    width: 300px;
    height: 225px;
  }

  @media only screen and (${device.laptopL}) {
    width: 400px;
    height: 300px;
  }
`;

const ItemImage = styled.img`
  background-color: gray;
  width: 100%;
  height: 100%;
`;

const Model = styled.div`
  font-weight: 600;
  text-align: left;
`;

const Price = styled.div`
  font-weight: bold;
  text-align: left;
`;

export default MultisplitOptionTableRow;
